import React from 'react';
import { useTranslation } from 'react-i18next';
import { MyQuotation } from '../../models/quotations/MyQuotation';
import PrimaryBtn from '../shared/Buttons/PrimaryButton';
import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';
import WarningButton from '../shared/Buttons/WarningButton';
import useMyQuotations from '../../hooks/quotations/useMyQuotations';
import SnackbarUtils from '../../utils/SnackbarUtils';
import { useNavigate } from 'react-router-dom';
import useConfirmDialog from '../../hooks/dialogs/useConfirmDialog';
import useFullScreenLoading from '../../hooks/useFullScreenLoading';

const StyledBox = styled(Box)(() => ({
    paddingBottom: '15px',
    display: 'flex',
    gap: '5px',
}));
export const MyQuotationDetailsActions: React.FC<{ quote: MyQuotation }> = (
    props
) => {
    const { t } = useTranslation('quotations', {
        keyPrefix: 'MY_QUOTATIONS',
    });
    const { quote } = props;
    const myQuotation = useMyQuotations();
    const today = new Date();
    const navigate = useNavigate();
    const confirmDialog = useConfirmDialog();
    const fullScreenLoading = useFullScreenLoading();

    const createOrder = () => {
        fullScreenLoading.setFullScreenLoading(true);
        myQuotation
            .createOrderFromQuotation({ quoteNo: quote.quoteNo })
            .then(() => {
                SnackbarUtils.success(t('ORDER_CREATED_SUCCESSFULLY'));
                navigate('/live-orders');
            })
            .finally(() => {
                fullScreenLoading.setFullScreenLoading(false);
            });
    };

    const handleCreateOrderAction = () => {
        confirmDialog.showDialog({
            title: t('CONFIRM_CREATE_ORDER.TITLE'),
            content: t('CONFIRM_CREATE_ORDER.CONTENT'),
            confirmText: t('CONFIRM_CREATE_ORDER.CONFIRM'),
            cancelText: t('CONFIRM_CREATE_ORDER.CANCEL'),
            onConfirm: () => createOrder(),
        });
    };

    const createPDF = () => {
        // myQuotation
        //     .createOrderFromQuotation({ quoteNo: quote.quoteNo })
        //     .then((resp) => {
        //         SnackbarUtils.success(t('ORDER_CREATED_SUCCESSFULLY'));
        //         navigate('/live-orders');
        //     });
    };

    const isExpired = (): boolean => {
        return new Date(quote.quoteValidToDate) > today;
    };

    return (
        <StyledBox>
            {quote.status == 'Released' && (
                <PrimaryBtn onClick={handleCreateOrderAction}>
                    {t('ACTIONS.CREATE_ORDER', {
                        number: quote.salesQuoteLines.length,
                    })}
                </PrimaryBtn>
            )}
            {quote.status == 'Released' &&
                quote.quoteValidToDate &&
                !isExpired && (
                    <WarningButton onClick={createPDF}>
                        {t('ACTIONS.GENERATE_PDF')}
                    </WarningButton>
                )}
        </StyledBox>
    );
};
